import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'fgb-facial-recognition-review-photo-failed',
  templateUrl: './facial-recognition-review-photo-failed.component.html',
  styleUrl: './facial-recognition-review-photo-failed.component.scss',
})
export class FacialRecognitionReviewPhotoFailedComponent implements OnInit, OnDestroy {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData = new FormControl();
  @Input() stepCounter: number = 4;
  @Input() isUploadInfo: boolean = false;
  @Output() isUploadInfoChange = new EventEmitter<boolean>();
  @Output() setStep = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  imageSrc: string = '';
  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.uploadedImage.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.imageSrc = data;
      }
    });
  }

  retakePhoto() {
    if (this.uploadedImage.value) {
      this.uploadedImage.setValue(null);
    }
    this.setStep.emit(1);
  }

  uploadedImageChange() {
    this.setStep.emit(2);
    this.isUploadInfo = true;
    this.isUploadInfoChange.emit(this.isUploadInfo);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
